/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export const injectGAScript = (integrationTypeAndURL, embedSettings) => {
    let ga = integrationTypeAndURL.integrationType === 'DFP_WITHOUT_SAFEFRAME' ? window.parent.parent["ga"] : window.parent["ga"];
    if (ga && ga.create) {
        callGAFunctions(ga, embedSettings);
    } else if (!integrationTypeAndURL.url.includes('localhost')) {
        createAndAppendGAScript(embedSettings);
    }
};



// ----- HELPER FUNCTIONS ----- //
const callGAFunctions = (ga, embedSettings) => {
    let hostname;
    try {
        hostname = window.top.location.hostname;
    } catch(e) {
        hostname = '';
    } finally {
        ga('create', embedSettings.googleAnalyticsID, 'auto', {'alwaysSendReferrer': 'true', 'name': 'Insticator_Embed_v4'});
        ga('Insticator_Embed_v4.send', 'pageview', `/${embedSettings.site.uuid}`);
        ga('Insticator_Embed_v4.set', 'referrer', hostname);
    }
};
const createAndAppendGAScript = embedSettings => {
    const gaScript = document.createElement('script');
    gaScript.innerHTML = `(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||` +
        `function(){(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)})` +
        `(window,document,'script','https://www.google-analytics.com/analytics.js','ga');` +
        `ga('create', '${embedSettings.googleAnalyticsID}', 'auto', {'alwaysSendReferrer': 'true'});` +
        `ga('set', 'checkProtocolTask', null);ga('send', 'pageview',  '/${embedSettings.site.uuid}');` +
        `ga('set', 'referrer','${embedSettings.site.url}');`;
    window.frameElement.contentDocument.head.appendChild(gaScript);
};